import { createTheme } from '@mui/material/styles';

// Brand palette — kept to the existing red/black/white identity, with
// richer neutrals so it reads premium instead of pure #f00 on #000.
export const brand = {
  red: '#e11414',
  redBright: '#ff1a1a',
  redDark: '#a30d0d',
  ink: '#0b0b0d',
  surface: '#141418',
  surfaceLight: '#1d1d22',
  line: 'rgba(255,255,255,0.10)',
};

const headingFont = '"Oswald", "Arial Narrow", sans-serif';
const bodyFont = '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif';

// Light mode keeps the white contact-form card working; the dark
// sections set their own backgrounds explicitly per-page.
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: brand.red, dark: brand.redDark, light: brand.redBright, contrastText: '#ffffff' },
    secondary: { main: brand.ink },
    text: { primary: '#17171a', secondary: 'rgba(0,0,0,0.6)' },
  },
  typography: {
    fontFamily: bodyFont,
    h1: { fontFamily: headingFont, fontWeight: 700, letterSpacing: '-0.5px', textTransform: 'uppercase' },
    h2: { fontFamily: headingFont, fontWeight: 700, letterSpacing: '-0.3px', textTransform: 'uppercase' },
    h3: { fontFamily: headingFont, fontWeight: 700, letterSpacing: '-0.3px', textTransform: 'uppercase' },
    h4: { fontFamily: headingFont, fontWeight: 600, letterSpacing: '0.2px', textTransform: 'uppercase' },
    h5: { fontFamily: headingFont, fontWeight: 600 },
    h6: { fontFamily: headingFont, fontWeight: 600 },
    button: { fontFamily: headingFont, fontWeight: 600, letterSpacing: '1px' },
    overline: { fontFamily: headingFont, fontWeight: 600, letterSpacing: '2px' },
  },
  shape: { borderRadius: 6 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'uppercase', borderRadius: 4, fontWeight: 600 },
      },
    },
  },
});

export default theme;
